import { useEffect, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { trackError } from 'helpers/track_error';

export default function useStickyState<Type>(
  defaultValue: Type,
  key: string
): [Type, Dispatch<SetStateAction<Type>>] {
  const [value, setValue] = useState<Type>(() => {
    try {
      const stickyValue = window.localStorage.getItem(key);

      if (stickyValue === null || stickyValue === undefined || stickyValue === 'undefined') {
        return defaultValue;
      }

      return JSON.parse(stickyValue);
    } catch (e) {
      trackError({
        error: new Error(`Error getting data from localStorage for ${key}`),
      });
      return defaultValue;
    }
  });
  useEffect(() => {
    if (value !== null || value !== undefined) {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {
        trackError({
          error: new Error(`Error setting data to localStorage for ${key}:${value}`),
        });
      }
    }
  }, [key, value]);
  return [value, setValue];
}
